import { SVGProps } from "react";

import { CategoryStyles } from "@/config";

export default function CategoryIcon({
  name,
  ...rest
}: SVGProps<SVGSVGElement> & {
  name: string;
}) {
  if (!CategoryStyles[name]) {
    return null;
  }

  const { Icon, color } = CategoryStyles[name];
  return <Icon fill={color} {...rest} />;
}
